module.exports = __webpack_public_path__ + "static/img/feirou.83e4e045.png";